// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__FQ9nv","description":"PatientConsentPreview_description___5U5e"};